import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, Clock, Mail } from "lucide-react";

const PendingApprovalModal = ({ show, userEmail, onClose }) => {
  useEffect(() => {
    // Prevent scrolling when modal is open
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  if (!show) return null;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ background: 'rgba(8,11,20,.7)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)', padding: 20 }}
    >
      <div
        className="w-full max-w-md animate-fade-in"
        style={{ background: '#12162A', border: '1px solid rgba(255,255,255,.12)', borderRadius: 22, maxHeight: '90vh', overflow: 'auto', boxShadow: '0 40px 90px -30px rgba(0,0,0,.85)', fontFamily: "'Work Sans', sans-serif" }}
      >
        {/* Header */}
        <div
          className="px-6 py-7 text-center relative"
          style={{ background: 'linear-gradient(120deg,#B45309,#78350F)', borderTopLeftRadius: 22, borderTopRightRadius: 22, overflow: 'hidden' }}
        >
          <img
            src="/assets/website/symbol-white.svg"
            alt=""
            aria-hidden="true"
            style={{ position: 'absolute', right: -28, top: -28, width: 150, height: 150, opacity: 0.06, animation: 'szspin 80s linear infinite', pointerEvents: 'none' }}
          />
          <div className="flex items-center justify-center mx-auto mb-4 relative" style={{ width: 64, height: 64, borderRadius: '9999px', background: 'rgba(255,255,255,.18)' }}>
            <Clock className="w-8 h-8 text-white" />
          </div>
          <h3 className="text-2xl font-bold text-white relative" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Profile Submitted for Approval
          </h3>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="text-center">
            <p className="text-lg mb-4" style={{ color: '#fff' }}>
              Thank you! Your profile has been submitted and is now being reviewed by our admin team.
            </p>
            <p className="text-sm mb-6" style={{ color: 'rgba(255,255,255,.6)' }}>
              We'll send you an email at <strong style={{ color: '#fff' }}>{userEmail}</strong> once your profile is approved.
            </p>
          </div>

          {/* What's Next */}
          <div className="p-4" style={{ borderRadius: 12, background: 'rgba(40,192,208,.08)', borderLeft: '4px solid #28C0D0' }}>
            <div className="flex items-start">
              <Mail className="w-5 h-5 mr-3 flex-shrink-0 mt-1" style={{ color: '#28C0D0' }} />
              <div>
                <h4 className="font-bold text-sm" style={{ color: '#fff' }}>What Happens Next?</h4>
                <ul className="text-sm mt-2 space-y-1" style={{ color: 'rgba(255,255,255,.6)' }}>
                  <li>✓ Admin reviews your profile</li>
                  <li>✓ You'll receive an email notification</li>
                  <li>✓ Once approved, you can post jobs and apply</li>
                </ul>
              </div>
            </div>
          </div>

          {/* While You Wait */}
          <div className="p-4" style={{ borderRadius: 12, background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.1)' }}>
            <h4 className="font-bold text-sm mb-2" style={{ color: '#fff' }}>While You Wait...</h4>
            <p className="text-sm" style={{ color: 'rgba(255,255,255,.6)' }}>
              You can browse the platform and view available jobs. However, you won't be able to apply for jobs or post listings until your profile is approved.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <Button
            onClick={handleClose}
            className="w-full font-semibold py-3 hover:opacity-90"
            style={{ background: '#28C0D0', color: '#06121A' }}
          >
            <CheckCircle className="w-4 h-4 mr-2" />
            Got it!
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalModal;
